<template>
    <div>
        <label class="v-label theme--light pr-4">{{label}}</label>
        <div>
            <v-card width=150 height=60 @click="change()" style="cursor: pointer" class="mb-4" :color="backgroundColor">
                <v-row no-gutters>
                    <v-col>
                        <v-auto-img :src="imagekey" height="60px" width="100px" v-if="imagekey" class="d-inline-block"/>
                        <v-btn v-else text color="zoezi-edit-color" height="60px" width="100%">{{$translate('Change')}}</v-btn>
                    </v-col>
                    <v-col v-if="imagekey">
                        <v-btn class="d-inline-block" icon style="margin-top: 6px" @click.stop="clear" :color="color"><v-icon>mdi-close</v-icon></v-btn>
                    </v-col>
                </v-row>
            </v-card>

            <v-text-field v-model="imagekey" :label="$translate('Image address or key')" />
        </div>

        <v-dialog
            v-model="showMediaLibrary"
            max-width="80%"
            scrollable
        >
            <v-card>
                <v-card-title class="headline zoezi-edit-color">
                    {{$translate('Choose image')}}
                    <v-btn icon @click="showMediaLibrary = false" class="ml-auto zoezi-edit-color"><v-icon>mdi-close</v-icon></v-btn>
                </v-card-title>

                <v-card-text>
                    <div v-if="hint" class="mt-2" v-text="hint" />
                    <media-library :columns="$vuetify.breakpoint.mobile ? 1 : 6" v-model="imagekey" v-on:change="changed" type="image" />
                </v-card-text>
            </v-card>
        </v-dialog>

    </div>
</template>

<script>
import MediaLibrary from './MediaLibrary.vue'
  export default {
    name: 'ImageSetting',
    props: ['value', 'label', 'backgroundColor', 'color', 'hint'],

    components: {
        MediaLibrary
    },
    computed: {
        shared() {
            return this.$root.shared;
        }
    },
    data: () => ({
        showMediaLibrary: false,
        imagekey: null
    }),
    methods: {
        changed(value) {
            this.showMediaLibrary = false;
            if (this.shared) {
                // For shared homepages we store the full url, https://someplace.zoezi.se/api/utils/file/download?key=...
                // instead of just the key. That makes it possible to use the same image on multiple homepages.
                value = this.$api.getImageUrl(value);
            }
            this.$emit('input', value);
            this.imagekey = value;
        },
        change() {
            this.showMediaLibrary = true;
        },
        clear() {
            this.changed(null);
        }
    },
    created() {
        this.imagekey = this.value;
    }
  }
</script>